import React, { useState } from "react";
import { CONSTANT_CURRENCY, CONSTANT_REDIRECT_TIME } from "../../../constant/common";
import { formatDateForView } from "../../../utils/formateDate";
import api from "../../../api/api";
import { toast } from "react-toastify";

const AdminBillingDetails = ({ userDetails, setActiveTab, getUserDetails }) => {

    const [isRenewToggle, setIsRenewToggle] = useState(false);

    const handleRenewChange = async () => {
        const payload = {
            users_id: userDetails?.users_id
        };
        try {
            const response = await api.post("update-users-autorenew", payload);

            if (response?.data?.status === true) {
                toast.success(response.data?.message);

                setIsRenewToggle(false);

                // setTimeout(() => {
                    getUserDetails();
                // }, CONSTANT_REDIRECT_TIME);

            } else {
                toast.error(response?.data?.message || "Failed .");
                return null;
            }
        } catch (error) {
            setIsRenewToggle(false);

            console.error("Error :", error);
            toast.error("Something went wrong. Please try again.");
            return null;
        }
        finally {
        }
    }

    return (
        <>

            <ul className="flex gap-2 text-base font-medium text-dark mb-5">
                <li>
                    <a href="#" className="text-blue">Billing</a>
                </li>
                <li>/</li>
                <li><span>Billing Details</span></li>
            </ul>
            <div className="bg-[#F4F4F4] px-6 py-12 rounded-[20px] w-full max-w-[860px]">
                <div className="grid grid-cols-6 gap-x-3 gap-y-0 md:gap-y-7">
                    <div className="col-span-6 md:col-span-2">
                        <p className="text-dark text-sm sm:text-base md:text-lg font-semibold">Practice Name :</p>
                    </div>
                    <div className="col-span-6 md:col-span-4 mb-3 md:mb-0">
                        <p className="text-dark text-sm sm:text-base md:text-lg font-medium">{userDetails?.practice_name}</p>
                    </div>
                    <div className="col-span-6 md:col-span-2">
                        <p className="text-dark text-sm sm:text-base md:text-lg font-semibold">Plan Type :</p>
                    </div>
                    <div className="col-span-6 md:col-span-4 mb-3 md:mb-0">
                        <div className="flex flex-wrap gap-3 items-center">
                            <p className="text-dark text-sm sm:text-base md:text-lg font-medium">{userDetails?.current_plan?.name} Plan</p>
                            {/* <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4.00335 21.7491C3.72596 21.7477 3.45281 21.6808 3.20619 21.5539C2.95956 21.4269 2.74644 21.2434 2.58422 21.0184C2.42199 20.7934 2.31524 20.5332 2.27269 20.2591C2.23014 19.985 2.25298 19.7047 2.33935 19.4411L3.18035 16.9411C3.27929 16.6618 3.26966 16.3556 3.15335 16.0831C2.18988 14.001 1.98982 11.6464 2.58821 9.43163C3.1866 7.2169 4.54528 5.28337 6.42618 3.96986C8.30709 2.65634 10.5902 2.04661 12.8756 2.24751C15.1609 2.44841 17.3027 3.44712 18.9255 5.06865C20.5484 6.69017 21.5489 8.83109 21.7518 11.1163C21.9546 13.4014 21.3468 15.6851 20.0348 17.5671C18.7229 19.4491 16.7905 20.8094 14.5763 21.4096C12.362 22.0099 10.0072 21.8118 7.92435 20.8501C7.64661 20.7304 7.33371 20.7211 7.04935 20.8241L4.56035 21.6601C4.38064 21.7193 4.19258 21.7494 4.00335 21.7491ZM12.0034 3.74907C10.6193 3.74627 9.25691 4.0923 8.04196 4.7552C6.827 5.4181 5.7987 6.37649 5.05203 7.54184C4.30537 8.70718 3.86442 10.0419 3.76992 11.4227C3.67542 12.8035 3.93041 14.1859 4.51135 15.4421C4.79012 16.0609 4.82372 16.7624 4.60535 17.4051L3.76235 19.9171C3.74706 19.9612 3.74496 20.0088 3.75633 20.0541C3.7677 20.0994 3.79203 20.1404 3.82635 20.1721C3.85848 20.2063 3.89983 20.2306 3.94542 20.242C3.991 20.2533 4.0389 20.2513 4.08335 20.2361L6.58335 19.3971C7.2317 19.1736 7.94107 19.2072 8.56536 19.4911C9.68562 20.005 10.9068 20.2612 12.1392 20.241C13.3715 20.2207 14.5837 19.9244 15.6864 19.374C16.7892 18.8235 17.7545 18.0328 18.5114 17.0601C19.2683 16.0874 19.7976 14.9574 20.0602 13.7532C20.3228 12.5489 20.3122 11.3012 20.029 10.1016C19.7459 8.90209 19.1974 7.78127 18.424 6.82162C17.6506 5.86198 16.6719 5.08791 15.5599 4.55636C14.4479 4.0248 13.2309 3.74928 11.9984 3.75007L12.0034 3.74907ZM13.0184 9.00007C13.0184 8.73485 12.913 8.4805 12.7255 8.29296C12.5379 8.10542 12.2836 8.00007 12.0184 8.00007H12.0084C11.811 8.00204 11.6187 8.06236 11.4555 8.17344C11.2924 8.28451 11.1658 8.44137 11.0916 8.62426C11.0175 8.80715 10.9991 9.0079 11.0388 9.20122C11.0785 9.39453 11.1745 9.57178 11.3148 9.71063C11.455 9.84949 11.6332 9.94374 11.8269 9.98152C12.0206 10.0193 12.2212 9.99892 12.4033 9.92295C12.5855 9.84698 12.741 9.71881 12.8505 9.55458C12.9599 9.39036 13.0183 9.19742 13.0184 9.00007ZM12.7484 15.0001V12.0001C12.7484 11.8012 12.6693 11.6104 12.5287 11.4697C12.388 11.3291 12.1973 11.2501 11.9984 11.2501C11.7994 11.2501 11.6087 11.3291 11.468 11.4697C11.3274 11.6104 11.2484 11.8012 11.2484 12.0001V15.0001C11.2484 15.199 11.3274 15.3897 11.468 15.5304C11.6087 15.6711 11.7994 15.7501 11.9984 15.7501C12.1973 15.7501 12.388 15.6711 12.5287 15.5304C12.6693 15.3897 12.7484 15.199 12.7484 15.0001Z" fill="#0052CC" />
                            </svg> */}
                            {/* {userDetails?.fk_pricing_plan_id != 3 &&
                                <button type="button"
                                    onClick={() => setActiveTab('pricingplan')}
                                    className="bg-green px-4 py-2 font-semibold text-sm sm:text-base text-white rounded-lg">
                                    Upgrade Plan
                                </button>
                            } */}
                            {userDetails?.fk_pricing_plan_id != 1 ? (
                                (() => {
                                    const isExpired = new Date(userDetails?.plan_expiry_date) < new Date();

                                    return (
                                        <button
                                            type="button"
                                            onClick={() => setActiveTab('pricingplan')}
                                            className={`px-4 py-2 font-semibold text-sm sm:text-base text-white rounded-lg ${isExpired ? 'bg-red-600 hover:bg-red-800' : 'bg-green'}`}
                                        >
                                            {isExpired ? 'Expired Renew Now' : 'Upgrade Plan'}
                                        </button>
                                    );
                                })()
                            ) :
                                (
                                    <button type="button"
                                        onClick={() => setActiveTab('pricingplan')}
                                        className="bg-green px-4 py-2 font-semibold text-sm sm:text-base text-white rounded-lg">
                                        Upgrade Plan
                                    </button>
                                )}

                        </div>
                    </div>
                    {userDetails?.fk_pricing_plan_id != 1 && (
                        <>
                            <div className="col-span-6 md:col-span-2">
                                <p className="text-dark text-sm sm:text-base md:text-lg font-semibold">Billing Frequency :</p>
                            </div>
                            <div className="col-span-6 md:col-span-4 mb-3 md:mb-0">
                                <p className="text-dark text-sm sm:text-base md:text-lg font-medium">Every 1 {userDetails?.current_plan?.duration}</p>
                            </div>
                            <div className="col-span-6 md:col-span-2">
                                <p className="text-dark text-sm sm:text-base md:text-lg font-semibold">Next Billing Date :</p>
                            </div>
                            <div className="col-span-6 md:col-span-4 mb-3 md:mb-0">
                                <p className="text-dark text-sm sm:text-base md:text-lg font-medium">{formatDateForView(userDetails?.plan_expiry_date)}</p>
                            </div>
                            <div className="col-span-6 md:col-span-2">
                                <p className="text-dark text-sm sm:text-base md:text-lg font-semibold">Auto Renew :</p>
                            </div>
                            <div className="col-span-6 md:col-span-4 mb-3 md:mb-0">
                                <div className="flex gap-3">
                                    <p id="statusText" className="text-dark text-sm sm:text-base md:text-lg font-medium">{userDetails?.plan_auto_renew === 1 ? 'Enable' : 'Disable'}</p>
                                    <label className="inline-flex items-center me-5 cursor-pointer" onClick={() => {
                                        setIsRenewToggle(true)
                                    }}>
                                        <input type="checkbox" value="" className="sr-only peer hidden"
                                            checked={userDetails?.plan_auto_renew === 1} id="toggleSwitch" />
                                        <div className="relative w-12 h-7 bg-red-50 border-2 border-red-500 rounded-full peer peer-checked:border-green peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-red-500 peer-checked:after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-green"></div>
                                    </label>
                                </div>
                            </div>
                            <div className="col-span-6 md:col-span-2">
                                <p className="text-dark text-sm sm:text-base md:text-lg font-semibold">Next Renew Amount :</p>
                            </div>
                            <div className="col-span-6 md:col-span-4 mb-3 md:mb-0">
                                <p className="text-dark text-sm sm:text-base md:text-lg font-medium">{CONSTANT_CURRENCY + userDetails?.current_plan?.price}</p>
                            </div>
                        </>
                    )}


                    <div id="statuspopup" className={`fixed bg-[#0000007A] top-0 left-0 h-screen w-full z-[999] justify-center items-center px-3 ${isRenewToggle ? 'flex' : 'hidden'}`}>
                        <div className="max-w-[630px] w-full mx-auto bg-white rounded-xl sm:rounded-2xl px-3 py-6 sm:py-10 sm:px-10 lg:px-20 innercard">
                            <div className="max-w-[312px] w-full flex justify-center items-center gap-6 flex-col mx-auto">
                                <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M36 0C16.1496 0 0 16.1498 0 36.0002C0 55.8506 16.1496 72 36 72C55.8504 72 72 55.8506 72 36.0002C72 16.1498 55.8504 0 36 0ZM36 65.4545C19.7585 65.4545 6.54545 52.2415 6.54545 36.0002C6.54545 19.759 19.7585 6.54545 36 6.54545C52.2415 6.54545 65.4545 19.759 65.4545 36.0002C65.4545 52.2415 52.2412 65.4545 36 65.4545Z" fill="#0052CC" />
                                    <path d="M35.9996 15.2734C33.5939 15.2734 31.6368 17.2318 31.6368 19.639C31.6368 22.0441 33.5939 24.0007 35.9996 24.0007C38.4053 24.0007 40.3624 22.0441 40.3624 19.639C40.3624 17.2318 38.4053 15.2734 35.9996 15.2734Z" fill="#0052CC" />
                                    <path d="M36 30.5449C34.1926 30.5449 32.7273 32.0102 32.7273 33.8176V53.454C32.7273 55.2614 34.1926 56.7267 36 56.7267C37.8074 56.7267 39.2727 55.2614 39.2727 53.454V33.8176C39.2727 32.0102 37.8074 30.5449 36 30.5449Z" fill="#0052CC" />
                                </svg>

                                <h4 className="text-center font-bold text-xl mg:text-2xl text-blue">Are you sure! <br />you want to change?</h4>
                                <div className="flex justify-between gap-3 w-full">
                                    <button
                                        type="button"
                                        onClick={() => {
                                            setIsRenewToggle(false)
                                        }}
                                        className="bg-transparent text-center text-dark text-sm sm:text-base font-semibold sm:w-full sm:max-w-[154px] rounded-lg py-2 px-3 sm:py-3 sm:px-0 flex items-center justify-center border border-dark cancelbtn">Cancel</button>
                                    <button
                                        type="button"
                                        onClick={handleRenewChange}
                                        className="bg-blue text-center text-white text-sm sm:text-base font-semibold sm:w-full sm:max-w-[154px] rounded-lg py-2 px-3 sm:py-3 sm:px-0 flex items-center justify-center border border-blue deletebtn">Change</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default AdminBillingDetails;
